import React, { useState,useRef  } from "react";
import { Link } from "react-router-dom";
const MenuItem = ({ item, isMobile = false ,setMobileTitle, setShowBack,menuStack= [], setMenuStack,closeMobileMenu}) => {
 const currentLevel = menuStack[menuStack.length - 1];
const [open, setOpen] = useState(false);

  const openMainPanel = (e) => {
    if (isMobile && item.all_subheaders?.length) {
      e.preventDefault();
      setMenuStack([item]);
      setMobileTitle(item.name.toUpperCase());
      setShowBack(true);
      }
   };

  const openSubPanel = (sub, e) => {
      e.preventDefault();
      setMenuStack((prev) => [...prev, sub]);
      setMobileTitle(sub.name.toUpperCase());
      setShowBack(true);
  };

const closeTimer = useRef(null);

const handleMouseEnter = () => {
  if (closeTimer.current) {
    clearTimeout(closeTimer.current);
  }
  setOpen(true);
};

const handleMouseLeave = () => {
  closeTimer.current = setTimeout(() => {
    setOpen(false);
  }, 200); // delay so user can move cursor
};
const hasMixedSubmenus =
  item.all_subheaders?.some(s => s.all_subheaders?.length > 0) && // has sub-submenu
  item.all_subheaders?.some(s => !s.all_subheaders?.length); 


  return (
    <>
      {/* DESKTOP MEGA MENU (UNCHANGED) */}
      {!isMobile && (
        <li
          className={`nav-item ${
            item.all_subheaders?.length ? "has-mega" : ""
          } ${open ? "is-open" : ""}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Link
            to={`/category/main_menu/${item.name}`}
            className="menu-item"
          >
            {item.name}
          </Link>

          {item.all_subheaders?.length > 0 && (
            <div
              className="mega"
              data-cols={item.columns?.length || item.all_subheaders.length}
              role="menu"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="cols">
               
                {item.all_subheaders?.length > 5 ? (
                  // ✅ CASE: Only one submenu
                  <div className="col single-column">
                    
                    {/* Main Menu Title */}
                    <h4>{item.name}</h4>

                    {/* Shop All Main Menu */}
                    <Link
                      to={`/category/main_menu/${item.name}`}
                      className="dropdown-link"
                    >
                      Shop All {item.name}
                    </Link>

                    {/* Submenu Items */}
                    {item.all_subheaders.map((subheader, idx) =>
                    
                        <Link
                          key={idx}
                          to={`/category/Category/${subheader.name}`}
                          className="dropdown-link"
                        >
                          {subheader.name}
                        </Link>
                     
                    )}
                  </div>
                ) : (
                  // ✅ NORMAL CASE (your existing structure)
                  item.all_subheaders.map((subheader, idx) =>
                    subheader.all_subheaders?.length > 0 ? (
                      <div key={idx} className="col">
                        {!hasMixedSubmenus && <h4>{subheader.name}</h4>}

                        <Link
                          to={`/category/Category/${subheader.name}`}
                          className="dropdown-link"
                        >
                          Shop All {subheader.name}
                        </Link>

                        {subheader.all_subheaders.map((child, cIdx) => (
                          <Link
                            key={cIdx}
                            to={`/category/subcategory/${child.name}`}
                            className="submenu-link"
                          >
                            {child.name}
                          </Link>
                        ))}
                      </div>
                    ) : (
                      <Link
                        key={idx}
                        to={`/category/subcategory/${subheader.name}`}
                        className="submenu-link singlelink"
                      >
                        {subheader.name}
                      </Link>
                    )
                  )
                )}
              </div>
            </div>
          )}
        </li>
      )}

      {/* MOBILE */}
      {isMobile && (
          <>
            {/* MAIN MENU */}
            {menuStack.length === 0 && (
              <li className="mobile-panel-menu">
                <Link
                  to={`/category/main_menu/${item.name}`}
                  className="mobile-panel-row"
                  onClick={openMainPanel}
                >
                  <span>{item.name}</span>
                  <svg viewBox="0 0 24 24"><polyline points="8 10 12 14 16 10"></polyline></svg>
                </Link>
              </li>
            )}

            {/* ACTIVE PANEL */}
            {menuStack.length > 0 && currentLevel && menuStack[0].id === item.id && (
                <li className="mobile-panel-menu">
                  <div className="mobile-panel">
                    <div className="mobile-panel-inner">

                      {/* shop all link */}
                      <Link
                        className="mobile-panel-link"
                         to={
                              menuStack.length === 1
                                ? `/category/main_menu/${currentLevel.name}`     // Main menu level
                                : `/category/Category/${currentLevel.name}`      // Submenu level
                            } onClick={closeMobileMenu}
                      >
                        Shop All {currentLevel.name}
                      </Link>

                      {/* list */}
                      <div className="mobile-panel-list">
                        {currentLevel.all_subheaders?.map((sub, idx) => (
                          sub.all_subheaders?.length > 0 ? (
                            <button
                              key={idx}
                              className="mobile-panel-row"
                              onClick={(e) => openSubPanel(sub, e)}
                            >
                              <span>{sub.name}</span>
                              <svg viewBox="0 0 24 24"><polyline points="8 10 12 14 16 10"></polyline></svg>
                            </button>
                            
                          ) : (
                            <Link
                              key={idx}
                              to={`/category/subcategory/${sub.name}`}
                              className="mobile-panel-row"  onClick={closeMobileMenu}
                            >
                              {sub.name}
                            </Link>
                          )
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
              )}
          </>
        )}
   </>
  );
};
export default MenuItem;